import requestApi from "@/utils/requestApi";

export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "show",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isAutoSignAuth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val && this.type === "sign") {
        this.fetchBasicCaAgreement();
      } else if (!val) {
        this.resetBasicCa();
      }
    },
  },
  data() {
    return {
      basicCaAgreementUrl: "",
      basicCaAgreementName: "",
      basicCaChecked: false,
      basicCaIsAuthFile: false,
      basicCaAuthFileDialogVisible: false,
      basicCaAuthFileTemplateUrl: "https://nfs.nxin.com/cxt/CA_Authorization2606.docx",
    };
  },
  methods: {
    resetBasicCa() {
      this.basicCaAgreementUrl = "";
      this.basicCaAgreementName = "";
      this.basicCaChecked = false;
      this.basicCaIsAuthFile = false;
      this.basicCaAuthFileDialogVisible = false;
    },
    async fetchBasicCaAgreement() {
      this.resetBasicCa();
      const { code, data } = await requestApi.post("sctrading/contract/mj/getBasicCa", {
        returnUrl: window.location.href,
        isAutoSignAuth: this.isAutoSignAuth,
      });
      if (code == "0" && data) {
        if (data.url) {
          this.basicCaAgreementUrl = data.url;
          this.basicCaAgreementName = data.name || "";
          this.basicCaIsAuthFile = !!data.isAuthFile;
        }else if (this.isAutoSignAuth && data.isAutoAuth === false && data.autoAuthUrl) {
          this.$confirm(data.tips || "您尚未完成自动签授权，请先前往授权", "提示", {
            confirmButtonText: "去授权",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              window.location.href = data.autoAuthUrl;
            })
            .catch(() => {
              this.localVisible = false;
            });
          return;
        }
      }
    },
    openBasicCaAgreement() {
      if (!this.basicCaAgreementUrl) {
        return;
      }
      if (this.basicCaIsAuthFile) {
        this.basicCaAuthFileDialogVisible = true;
        return;
      }
      window.location.href = this.basicCaAgreementUrl;
    },
    onBasicCaAuthFileReady() {
      this.basicCaAuthFileDialogVisible = false;
      window.location.href = this.basicCaAgreementUrl;
    },
    onBasicCaCheckedChange(val) {
      if (val) {
        this.openBasicCaAgreement();
      }
    },
    onConfirm() {
      if (this.basicCaAgreementUrl && !this.basicCaChecked) {
        this.basicCaChecked = true;
        this.openBasicCaAgreement();
        return;
      }
      this.$emit("confirm");
    },
  },
};
